import {
  getTaskList,
  getWafDetail,
  GetWafDetail,
  getListDetails,
  GetListDetails,
  getListDetailsElement,
  GetListDetailsElement,
  deleteList,
  DeleteList,
  GetPayload,
  getPayload,
  GetGroupOption,
  getGroupOption,
  GetWafChart,
  getWafChart,
  getArea,
  getAreaPlan,
  generateReport,
  GenerateReport,
  generateReportExcel,
  getAttckList,
  reTestTask,
  getSiteDropdown,
  stopTask,
  getTaskDetailUseCaseStatus,
  getTaskDetailUseCaseCount,
  getTaskDrawerDetail,
  getTaskListMain,
  getTaskListSub,
  getGroupList,
  deleteMainTask,
  TaskListProps,
  getTaskBaseInfo,
  getTaskDetailTemplateList,
  getTaskDetailCaseList,
  getTaskDetailCaseAttackType,
  getSecurityDeviceList,
} from '@/api/waf-list-task'
import { pausePlanTask, startPlanTask } from '@/api/waf-plans-task'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { getSiteTask } from '@/api/waf-data-comparison'

export const useGetTaskList = props => {
  const { getTaskListParams } = props
  const {
    data,
    runAsync: run,
    loading,
  } = useRequest(() => getTaskList(getTaskListParams), {
    refreshDeps: [getTaskListParams],
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取任务列表失败')
    },
  })

  return [run, loading] as const
}
export const useGenerateReport = () => {
  const { runAsync: run, loading } = useRequest((data: GenerateReport) => generateReport(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '创建报表失败')
    },
  })
  return [run, loading] as const
}

export const useGenerateReportExcel = () => {
  const { runAsync: run } = useRequest(data => generateReportExcel(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '导出详情信息失败')
    },
  })
  return [run] as const
}

export const useGetArea = () => {
  const { data, runAsync: run } = useRequest(() => getArea(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取安全域失败')
    },
  })

  return [data?.data.areas || [], run] as const
}

export const useGetSiteDropdown = () => {
  const { data, runAsync: run } = useRequest(() => getSiteDropdown(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取站点失败')
    },
  })

  return [data?.data?.siteList || [], run] as const
}
export const useGetAreaPlan = () => {
  const { data, runAsync: run } = useRequest(() => getAreaPlan(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取安全域失败')
    },
  })

  return [data?.data?.items || [], run] as const
}
export const useGetWafDetail = () => {
  const { runAsync: run } = useRequest((params: GetWafDetail) => getWafDetail(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取任务列表数量失败')
    },
  })

  return [run] as const
}
// 获取模板列表详情_
export const useGetListDetails = () => {
  const { runAsync: run } = useRequest((params: GetListDetails) => getListDetails(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取模板列表详情失败')
    },
  })

  return [run] as const
}
// 获取URL列表
interface GetListDetailsElementProps {
  listDetailsElementParams: GetListDetailsElement
}
export const useGetListDetailsElement = (props: GetListDetailsElementProps) => {
  const { listDetailsElementParams } = props
  const { runAsync: run, data } = useRequest(
    () => getListDetailsElement(listDetailsElementParams),
    {
      refreshDeps: [listDetailsElementParams],
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '获取Payloads列表失败')
      },
    },
  )

  return [run, data?.data] as const
}
// 删除列表
export const useDeleteList = () => {
  const { runAsync: run, loading } = useRequest((data: DeleteList) => deleteList(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '删除任务失败')
    },
  })
  return [run, loading] as const
}
// 获取下拉列表
export const useGetGroupOption = () => {
  const { data, runAsync: run } = useRequest((datas: GetGroupOption) => getGroupOption(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取下拉列表失败')
    },
  })
  return [data?.data?.items || [], run] as const
}
// 获取危险等级
export const useGetWafChart = () => {
  const { runAsync: run } = useRequest((datas: GetWafChart) => getWafChart(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取危险等级失败')
    },
  })
  return [run] as const
}

// 获取模板列表详情右侧
export const useGetPayload = () => {
  const { runAsync: run } = useRequest((params: GetPayload) => getPayload(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取模板列表详情失败')
    },
  })

  return [run] as const
}

// 获取详情页ATTCK
export const useGetAttckList = () => {
  const { data, runAsync: run } = useRequest(params => getAttckList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取ATT&CK失败')
    },
  })

  return [data?.data?.items || [], run] as const
}

// 任务复测
export const useRetestTask = () => {
  const { runAsync: run, loading } = useRequest(params => reTestTask(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '任务复测失败')
    },
  })

  return [run, loading] as const
}

export const useGetTaskBySite = () => {
  const {
    runAsync: run,
    loading,
    data,
  } = useRequest((site_url: string) => getSiteTask(site_url), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取站点下任务失败')
    },
  })
  return [data?.data?.items || [], run, loading] as const
}

// 停止任务
export const useStopTask = () => {
  const { runAsync: run } = useRequest(data => stopTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '任务停止失败')
    },
  })
  return [run] as const
}

// 获取任务详情用例状态列表
export const useGetTaskDetailUseCaseStatus = () => {
  const { runAsync: run, data } = useRequest(params => getTaskDetailUseCaseStatus(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取例状态列表失败')
    },
  })
  return [run, data?.data?.list || []] as const
}

// 任务结果 根据用例状态统计用例数
export const useGetTaskDetailUseCaseCount = () => {
  const { runAsync: run } = useRequest(params => getTaskDetailUseCaseCount(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取例状态列表失败')
    },
  })
  return [run] as const
}

// 获取分组列表 (筛选)
export const useGetGroupList = () => {
  const { runAsync: run, data } = useRequest(params => getGroupList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取分组列表失败')
    },
  })

  return [run, data?.data?.list || []] as const
}

// 获取任务详情
export const useGetTaskDetail = () => {
  const { runAsync: run, data } = useRequest((id: string) => getTaskDrawerDetail({ taskId: id }), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取任务详情失败')
    },
  })

  return [run, data?.data] as const
}

// 主任务列表
export const useGetTaskListMain = () => {
  const { runAsync: run, loading } = useRequest(params => getTaskListMain(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取主任务列表失败')
    },
  })
  return [run, loading] as const
}

// 子任务列表
export const useGetTaskListSub = () => {
  const { runAsync: run, loading } = useRequest(
    (id: string, params: TaskListProps) => getTaskListSub(id, params),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '获取子任务列表失败')
      },
    },
  )
  return [run, loading] as const
}

// 删除主任务
export const useDeleteMainTask = () => {
  const { runAsync: run, loading } = useRequest(data => deleteMainTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '删除主任务失败')
    },
  })
  return [run, loading] as const
}

// 计划任务开始任务
export const useStartPlanTask = () => {
  const { data, runAsync: run } = useRequest(params => startPlanTask(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '任务启动失败')
    },
  })
  return [run] as const
}
// 计划任务暂停任务
export const usePausePlanTask = () => {
  const { runAsync: run } = useRequest(params => pausePlanTask(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '任务暂停失败')
    },
  })
  return [run] as const
}

//  获取任务基础信息
export const useGetTaskBaseInfo = () => {
  const { runAsync: run, data } = useRequest(params => getTaskBaseInfo(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取任务基础信息失败')
    },
  })

  return [run, data?.data] as const
}

// 2.0.1

// 任务详情关联模板列表
export const useGetTaskDetailTemplateList = () => {
  const { runAsync: run, loading } = useRequest(params => getTaskDetailTemplateList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取关联模板列表失败')
    },
  })

  return [run, loading] as const
}

// 任务详情关联模板获取用例列表
export const useGetTaskDetailCaseList = () => {
  const { runAsync: run, loading } = useRequest(params => getTaskDetailCaseList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取关联模板用例列表失败')
    },
  })

  return [run, loading] as const
}

// 关联模板用例的攻击类型筛选
export const useGetTaskDetailCaseAttackType = () => {
  const { data, runAsync: run } = useRequest(params => getTaskDetailCaseAttackType(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取关联模板用例攻击类型失败')
    },
  })

  return [data?.data?.list || [], run] as const
}

// 获取安全设备列表 (筛选)
export const useGetSecurityDeviceList = () => {
  const { runAsync: run, data } = useRequest(() => getSecurityDeviceList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取安全设备列表失败')
    },
  })

  return [run, data?.data?.list || []] as const
}
